module.exports = __webpack_public_path__ + "static/media/reportgrey.20b0332a.svg";